import { CoachesTablePage } from 'widgets/coaches';

const Coaches = () => (
  <CoachesTablePage />
);

export default Coaches;
